(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("@ali/visualengine-utils"), require("lodash"), require("@ali/visualengine"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "@ali/visualengine-utils", "lodash", "@ali/visualengine"], factory);
	else if(typeof exports === 'object')
		exports["operate-components"] = factory(require("React"), require("@ali/visualengine-utils"), require("lodash"), require("@ali/visualengine"));
	else
		root["operate-components"] = factory(root["React"], root["VisualEngineUtils"], root["_"], root["VisualEngine"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__18__, __WEBPACK_EXTERNAL_MODULE__36__) {
return 